{
  "sectionId": "payablePARates",
  "header": "Payable - Personal Assistant Rates",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "rate",
      "fieldName": "rate",
      "label": "Rate",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter the rate.",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "code",
      "fieldName": "code",
      "label": "Service code",
      "type": "select",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a service code.",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "union",
      "fieldName": "union",
      "label": "Union",
      "type": "radio",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select union",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "cbatypeLkp",
      "fieldName": "cbatypeLkp",
      "label": "CBA Type",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select CBA Type",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "grandFathered",
      "fieldName": "grandFathered",
      "label": "GrandFathered",
      "type": "radio",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select GrandFathered",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "consumerTypeLkp",
      "fieldName": "consumerTypeLkp",
      "label": "Participant Type",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Participant Type",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "fromdate",
      "fieldName": "fromdate",
      "label": "Start Date",
      "type": "datepicker",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select start date",
      "isAvailable": "Y",
      "placeholder": "MM/DD/YYYY"
    },
    {
      "attribute_ID": "todate",
      "fieldName": "todate",
      "label": "End Date",
      "type": "datepicker",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select end date",
      "isAvailable": "Y",
      "placeholder": "MM/DD/YYYY"
    },
    {
      "attribute_ID": "region",
      "fieldName": "region",
      "label": "Region",
      "type": "text",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a region.",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "county",
      "fieldName": "county",
      "label": "County",
      "type": "text",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select county",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "modifierCode1",
      "fieldName": "modifierCode1",
      "label": "Modifier",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Modifier",
      "isAvailable": "Y"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 2,
          "attribute_ID": [
            "rate"
          ],
          "functionParams": {
            "ErrMsg": "Please enter the rate."
          }
        },
        {
          "validatorid": 3,
          "attribute_ID": [
            "code"
          ],
          "functionParams": {
            "ErrMsg": "Please select a service code."
          }
        },
        {
          "validatorid": 4,
          "attribute_ID": [
            "fromdate"
          ],
          "functionParams": {
            "ErrMsg": "Please select a start date."
          }
        },
        {
          "validatorid": 5,
          "attribute_ID": [
            "region"
          ],
          "functionParams": {
            "ErrMsg": "Please enter a region"
          }
        }
      ]
    },
    {
      "whatToCheck": "checkFieldValue",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "conditionalCheck",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "customValidator",
      "clientOrServer": "C",
      "attributes": []
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Submit",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": [1, 2, 3, 4,5]
        },
        {
          "checkType": "checkFieldValue",
          "validatorid": []
        },
        {
          "checkType": "conditionalCheck",
          "validatorid": []
        },
        {
          "checkType": "customValidator",
          "validatorid": []
        }
      ]
    }
  ]
}